import React, { useState } from 'react';
import { useAsync } from 'react-async';
import { useTranslation } from 'react-i18next';
import TouchableItem from '../../../../common/components/basic/TouchableItem';
import styles from '../../../../common/utils/styles/css/styles';
import firebase from '../../../../common/firebase';
import Alert from '../../../../common/components/basic/Alert';
import LoadingCircle from '../../../../common/components/basic/LoadingCircle';

export default function UnverifiedEmail() {
  async function handleResendVerificationEmail() {
    if (firebase.auth().currentUser) {
      return firebase.auth().currentUser.sendEmailVerification();
    }
  }
  const { isLoading, error, data, run } = useAsync<any>({ deferFn: handleResendVerificationEmail });
  const { t } = useTranslation();
  return (
    <div css={styles.tac}>
      <h1 css={styles.mtm}>
        {t('signin.message.email_unverified.title', 'Email verification required')}
      </h1>
      {isLoading ? (
        <div css={styles.flexMiddle}>
          <LoadingCircle />
        </div>
      ) : (
        <div>
          {!!data || !!error ? (
            <div css={styles.mvxl}>
              <Alert
                type={error ? 'danger' : 'success'}
                title={
                  error
                    ? t('general.error')
                    : t('signin.form.alert.have_send_email.title', 'Email Sent!')
                }
              >
                {error
                  ? error.message
                  : t(
                      'signin.form.alert.have_send_email.subtitle',
                      "We've sent you another email. If you don't see it please check your spam folder."
                    )}
              </Alert>
            </div>
          ) : (
            <p>
              {t(
                'signin.message.email_unverified.subtitle_1',
                "We've sent you a verification email. Please follow the link to activate your account."
              )}
            </p>
          )}
          <div css={[styles.mtl, styles.title3]}>
            {t('signin.message.email_unverified.subtitle_2_1', "Didn't receive an email?")}
            &nbsp;
            <TouchableItem css={styles.fcp} onClick={run}>
              {t('signin.message.email_unverified.subtitle_2_button', 'Click here')}
            </TouchableItem>
            &nbsp;
            {t('signin.message.email_unverified.subtitle_2_2', 'to get another one.')}
          </div>
        </div>
      )}
    </div>
  );
}
